// API Endpoints
export const API_ENDPOINTS = {
  CUSTOMIZATIONS: '/customizations',
  OPTIONS: '/options',
  CATEGORIES: '/categories',
  CATEGORY_ITEMS: (categoryId: number) => `/categories/${categoryId}/items`,
  CUSTOMIZATION_STOCK_TOGGLE: (customizationId: number) => `/customizations/stock-toggle?customization=${customizationId}`,
  CLONE_CUSTOMIZATION: '/customizations/clone',
} as const;

// Submission Types
export const SUBMISSION_TYPES = {
  NAME: 'name',
  OPTIONS: 'options',
  ADD_TO_ITEMS: 'addtoitems',
  CUSTOMIZATION_RULES: 'customizationrules',
  CREATE: 'create',
} as const;

// Placeholder Images
export const PLACEHOLDER_IMAGES = {
  ITEM: 'https://via.placeholder.com/50',
} as const;

// Common Messages
export const MESSAGES = {
  LOADING_CATEGORIES: 'Loading categories...',
  LOADING_ITEMS: 'Loading items...',
  NO_CATEGORIES_FOUND: 'No categories found',
  NO_ITEMS_FOUND: 'No items found in this category',
  NO_CATEGORIES_AVAILABLE: 'No categories available',
  NO_CATEGORIES_MATCHING_SEARCH: 'No categories found matching your search',
  CUSTOMIZATION_NAME_REQUIRED: 'Customization name is required.',
  CUSTOMIZATION_NAME_CANNOT_BE_EMPTY: 'Customization name cannot be empty.',
  CUSTOMIZATION_CREATED_SUCCESS: 'Customization created successfully!',
  CUSTOMIZATION_UPDATED_SUCCESS: 'Customization updated successfully.',
  CUSTOMIZATION_DELETED_SUCCESS: 'Customization deleted successfully.',
  OPTIONS_UPDATED_SUCCESS: 'Options updated successfully.',
  ITEMS_UPDATED_SUCCESS: 'Items updated successfully.',
  RULES_UPDATED_SUCCESS: 'Rules updated successfully.',
  OPTION_CREATED_SUCCESS: 'Option created successfully.',
  OPTION_UPDATED_SUCCESS: 'Option updated successfully.',
  OPTION_REMOVED_SUCCESS: 'Option removed successfully.',
  STOCK_STATUS_UPDATED: 'Stock status updated',
  FAILED_TO_CREATE: 'Failed to create customization.',
  FAILED_TO_UPDATE: 'Failed to update customization.',
  FAILED_TO_DELETE: 'Failed to delete customization.',
  FAILED_TO_UPDATE_OPTION: 'Failed to update option.',
  FAILED_TO_SAVE_OPTION: 'Unable to save the option.',
} as const;


